import { supabase } from './supabase';

export const founderService = {
  async isFounder(userId: string): Promise<boolean> {
    const { data, error } = await supabase
      .from('profiles')
      .select('is_founder')
      .eq('id', userId)
      .maybeSingle();

    if (error || !data) {
      return false;
    }

    return data.is_founder === true;
  },

  async checkFounderAccess(): Promise<boolean> {
    const { data: { user } } = await supabase.auth.getUser();

    if (!user) {
      return false;
    }

    return await this.isFounder(user.id);
  },

  async getCurrentFounder() {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('is_founder', true)
      .maybeSingle();

    if (error) {
      console.error('Error fetching founder:', error);
      return null;
    }

    return data;
  },

  async setFounder(userId: string): Promise<boolean> {
    const { data: existingFounder } = await supabase
      .from('profiles')
      .select('id')
      .eq('is_founder', true)
      .maybeSingle();

    if (existingFounder && existingFounder.id !== userId) {
      console.error('A founder already exists');
      return false;
    }

    const { error } = await supabase
      .from('profiles')
      .update({ is_founder: true })
      .eq('id', userId);

    if (error) {
      console.error('Error setting founder:', error);
      return false;
    }

    return true;
  },

  async removeFounder(userId: string): Promise<boolean> {
    const { error } = await supabase
      .from('profiles')
      .update({ is_founder: false })
      .eq('id', userId);

    if (error) {
      console.error('Error removing founder:', error);
      return false;
    }

    return true;
  },

  redirectToLogin() {
    window.location.href = '/';
  },

  redirectToUnauthorized() {
    window.location.href = '/';
  }
};
